<span class="tag tag--large tag--<%= colorClass %>"><button class="tag__close icon-close" data-close <%= attrs %>></button> <%= label %></span>
